import { useQuery } from '@tanstack/react-query';

import missionQueries from '@carers/views/Missions/utils/missionQueryFactory';

const useGetMissionDetail = (id: string) => useQuery(missionQueries.detail(id));

export default useGetMissionDetail;
